import {
  HttpEvent,
  HttpHandlerFn,
  HttpHeaders,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/_current/environment';
import { Observable } from 'rxjs';
import { AdminAuthService } from '../admin-auth/admin-auth.service';
import { AdminTenantService } from '../admin-tenant/admin-tenant.service';

function addUserToken(token: string, headers: HttpHeaders): HttpHeaders {
  return token ? headers.append('Authorization', 'Bearer ' + token) : headers;
}

function addJsonContentTypeHeader(headers: HttpHeaders): HttpHeaders {
  return headers.set('Content-Type', 'application/json');
}

function addJsonReturnTypeHeader(headers: HttpHeaders): HttpHeaders {
  return headers.set('Accept', 'application/json');
}

export function adminInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const adminAuthService = inject(AdminAuthService);
  const adminTenantService = inject(AdminTenantService);
  let headers = req.headers;
  const isAaptivRequest =
    req.url.includes(environment.aaptivServiceUrl) ||
    req.url.includes('localhost:3000');
  if (isAaptivRequest) {
    const token = adminAuthService.getToken();
    if (token) {
      headers = addUserToken(token, headers);
    }

    const tenantId = adminTenantService.getTenantIdFromStorage();
    if (tenantId) {
      headers = headers.append('X-AAPTIV-TENANT-ID', tenantId);
      headers = headers.append('X-AAPTIV-CONTENT-ORIGIN', 'aaptiv');
    }

    if (!(req.body instanceof FormData)) {
      headers = addJsonContentTypeHeader(headers);
    }
    headers = addJsonReturnTypeHeader(headers);
  }

  const clonedReq = req.clone({
    headers,
  });

  return next(clonedReq);
}
